var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
})(HttpMethod || (HttpMethod = {}));
export const sendRequest = ({ url, method, data, expectedHttpCodeResponse }) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };
    const response = yield axios({ method, url, headers, data }).catch(e => {
        throw new Error(e.response.data);
    });
    if (response.status !== expectedHttpCodeResponse) {
        throw new Error(response.toString());
    }
    return response.data;
});
